// components/Slider.jsx
import React from "react";

export default function Slider3D({ images = [] }) {
  return (
    <div
  className="slider"
  style={{ "--quantity": images.length }}
>
  {images.map((img, index) => (
    <div
      className="item"
      style={{ "--position": index + 1 }}
      key={index}
    >
      <img src={img} alt={`resume-${index}`} />
    </div>
  ))}
</div>

  );
}
